import { cortesViewRoles } from '../../acciones-roles/departamentos/cortes-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const CortesRoutes: SideBarButton = {
  data: {
    name: 'Cortes',
    appendUrl: './cortes',
    roles: cortesViewRoles.verDepartment,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Cortes',
        url: '/main',

        roles: cortesViewRoles.verCortes,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Inspecciones',
        url: '/inspection/cut-order',
        roles: cortesViewRoles.verInspection,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Retrabajo',
        url: '/retrabajo/cut-order',
        roles: cortesViewRoles.verInspection,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: cortesViewRoles.verValidacion,
      },
      options: PreConfigButton3,
    },

    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',

        roles: cortesViewRoles.verEtiquetas,
      },
      options: PreConfigButton3,
    },
  ],
};
